import { render, staticRenderFns } from "./businessContactConfig.vue?vue&type=template&id=29b8fa7e&scoped=true"
import script from "./businessContactConfig.vue?vue&type=script&lang=js"
export * from "./businessContactConfig.vue?vue&type=script&lang=js"
import style0 from "./businessContactConfig.vue?vue&type=style&index=0&id=29b8fa7e&lang=css"
import style1 from "./businessContactConfig.vue?vue&type=style&index=1&id=29b8fa7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_d02125917f7c66a571cdcbfa3dd68341/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b8fa7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29b8fa7e')) {
      api.createRecord('29b8fa7e', component.options)
    } else {
      api.reload('29b8fa7e', component.options)
    }
    module.hot.accept("./businessContactConfig.vue?vue&type=template&id=29b8fa7e&scoped=true", function () {
      api.rerender('29b8fa7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/base/businessContactConfig.vue"
export default component.exports